import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Copilot from "@/pages/Copilot";
import Funnels from "@/pages/Funnels";
import Objections from "@/pages/Objections";
import History from "@/pages/History";
import Team from "@/pages/Team";
import Admin from "@/pages/Admin";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        A carregar…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Copilot /></Protected>} />
            <Route path="/copilot" element={<Protected><Copilot /></Protected>} />
            <Route path="/funnels" element={<Protected><Funnels /></Protected>} />
            <Route path="/objections" element={<Protected><Objections /></Protected>} />
            <Route path="/history" element={<Protected><History /></Protected>} />
            <Route path="/team" element={<Protected><Team /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
